// Public, processor-neutral Card Management capability shapes. These mirror the
// backend CapabilityDecision / capabilities response from extend-api
// (physical-card-management) byte-for-byte. This is the single source of truth
// for these types — do NOT redefine them inside components.

export type CapabilityAvailability = 'AVAILABLE' | 'READ_ONLY' | 'UNAVAILABLE'

export type CapabilityExecution =
  | 'DIRECT'
  | 'APPROVAL_REQUIRED'
  | 'STAGING_ONLY'
  | 'NONE'

export type CapabilityBacking = 'STAGING' | 'LIVE' | 'NONE'

// The one action the demo gate hinges on today. When the full backend
// CapabilityResolver lands it returns more actions in the same array
// (freeze, mcc, limits, …) and the UI reuses hasAvailableCapability for each.
export const CARD_MANAGEMENT_VIEW_ACTION = 'VIEW_PHYSICAL_CARD_MANAGEMENT'

export interface CapabilityDecisionResponse {
  action: string
  availability: CapabilityAvailability
  execution: CapabilityExecution
  backing: CapabilityBacking
  reasonCode: string | null
}

export interface CardManagementCapabilitiesResponse {
  organizationId: string
  capabilities: CapabilityDecisionResponse[]
}

// Pure helper: is the given action offered as AVAILABLE in this capability set?
// The server has already folded role, the kill-switch, and per-card
// enrollment into the decision — the UI must not re-derive any of that.
export const hasAvailableCapability = (
  capabilities: CapabilityDecisionResponse[],
  action: string,
): boolean =>
  capabilities.some(
    (capability) =>
      capability.action === action && capability.availability === 'AVAILABLE',
  )
